export const FOLDER_NAME_MAX_LENGTH = 50;

const UNSUPPORTED_FOLDER_NAME_CHARACTERS = /[\p{Cc}\\/#?%]/u;

export const SUPPORTED_FOLDER_NAME_CHARACTERS = /^(?!\.{1,2}$)[^\p{Cc}\\/#?%]{1,50}$/u;

export function normalizeFolderName(name: string): string {
  return name.trim().normalize('NFC');
}

export function isValidFolderName(name: string): boolean {
  return (
    Array.from(name).length <= FOLDER_NAME_MAX_LENGTH
    && !UNSUPPORTED_FOLDER_NAME_CHARACTERS.test(name)
    && SUPPORTED_FOLDER_NAME_CHARACTERS.test(name)
  );
}
